import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '@/components/modal';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  isPending,
}: DeleteConfirmModalProps) {
  const { t } = useTranslation();

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={t('feed.delete_post_title')}
      message={t('feed.delete_post_message')}
      variant="danger"
      isPending={isPending}
      confirmLabel={t('feed.delete')}
      cancelLabel={t('common.cancel')}
    />
  );
}
